/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./double-check-dialog.vue?vue&type=template&id=3b40c2be&scoped=true&"
import script from "./double-check-dialog.vue?vue&type=script&lang=js&"
export * from "./double-check-dialog.vue?vue&type=script&lang=js&"
import style0 from "./double-check-dialog.vue?vue&type=style&index=0&id=3b40c2be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40c2be",
  null
  
)

export default component.exports